import React from 'react';
import { node, string, func, oneOfType, bool, object } from 'prop-types';

import Button from '@mui/material/Button';
import PageRow from './../PageRow';

const ButtonForm = ({
  style,
  className,
  color,
  variant,
  onClick,
  disabled,
  children,
  'data-testid': dataTestId,
}) => {
  return (
    <PageRow>
      <Button
        style={style}
        className={className}
        color={color}
        variant={variant}
        onClick={onClick}
        disabled={disabled}
        fullWidth
        data-testid={dataTestId}
      >
        {children}
      </Button>
    </PageRow>
  );
};

ButtonForm.propTypes = {
  onClick: func,
  className: string,
  style: oneOfType([object, func]),
  color: string,
  disabled: bool,
  children: node,
  variant: string,
  'data-testid': string,
};

ButtonForm.defaultProps = {
  onClick: () => {},
  className: '',
  style: null,
  color: 'primary',
  disabled: false,
  children: null,
  variant: 'contained',
  'data-testid': null,
};

export default ButtonForm;
